import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { ConsignedOrderDropDownMenu } from ".";
import { Link } from "react-router-dom";

const TYPE_OF_ORDER = {
  SOPOrder: {
    id: 1,
    text: "Check the orders you would like to be combined into one bill of lading.",
  },
  ConsignedOrder: {
    id: 2,
    text: "Select the third party billing address for this consigned order",
  },
};

export default function ShippingScheduleConsignedGrid(props) {
  const [data, setData] = useState();
  const [working, setWorking] = useState(false);

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  function getExcel() {
    setWorking(true);
    props.exportXlsxCallback();
    setWorking(false);
  }

  let alreadyDisplayedList = [];
  return (
    <>
      <Row className="align-items-center">
        <Col className="transparent-background">
          <ButtonGroup className="float-end">
            {props.data && props.data.length && props.exportXlsxCallback && (
              <Button
                title="Download as .xlsx"
                className="shredButtonExcel float-end ms-2"
                onClick={() => getExcel()}
                disabled={working}
              >
                <FontAwesomeIcon icon="file-excel" size="lg" />
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Table size="sm" className="data-table">
        <thead className="table-header">
          <tr>
            <th style={{ width: "11%" }}>Order Number</th>
            <th style={{ width: "11%" }}>Customer</th>
            <th style={{ width: "5%" }}>Customer P/N</th>
            <th style={{ width: "5%" }}>Item</th>
            <th style={{ width: "5%" }}>
              <span>
                Ordered <br /> QTY
              </span>
            </th>
            <th style={{ width: "5%" }}>Frieght Carrier</th>
          </tr>
        </thead>
        <tbody>
          {_.map(props.data, (dataCell, index) => {
            const alreadyDisplayed = _.includes(
              alreadyDisplayedList,
              dataCell.orderId
            );
            alreadyDisplayedList.push(dataCell.orderId);
            return (
              <tr
                key={`index-${index}`}
                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
              >
                {alreadyDisplayed ? (
                  <td className="data-cell"  colSpan={1}/>
                ) : (
                  <ConsignedOrderDropDownMenu
                    invoiceNumber={null}
                    orderId={dataCell.orderId}
                    itemNumber={dataCell.itemNumber}
                    customerId={dataCell.customerId}
                    orderType={TYPE_OF_ORDER.ConsignedOrder.id}
                  />
                )}
                <td className="data-cell">                 
                  <Link
                    style={{textDecoration: "none"}}
                    className="shredLink fw-bold"                         
                    to={`/customer-dashboard/${dataCell.customerId}`}
                    >
                      {dataCell.customerIdName}
                  </Link>
                </td>
                <td className="data-cell" children={dataCell.customerItemNumber} />
                <td className="data-cell" children={dataCell.itemWithDesc} />
                <td className="data-cell" children={dataCell.totalQty} />
                <td></td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
